import { createContext, useContext, useLayoutEffect, useState } from "react";

import { AuthWrapper } from "@/lib/aws-amplify";

import { CircleLoadingScreen } from "@/components/ui/loading/circle-screen";

type AuthContextType = {
	isSignedIn: boolean;
	signInCallback: () => void;
	signOutCallback: () => void;
};

const AuthContext = createContext<AuthContextType>({} as unknown as AuthContextType);

export const useAuth = () => {
	const authContext = useContext(AuthContext);

	if (!authContext) {
		throw new Error("AuthContext が見つかりません");
	}

	return authContext;
};

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
	// ログイン状態を管理するステート
	const [isSignedIn, setIsSignedIn] = useState(false);

	/**
	 * サインイン時に呼び出される
	 * RoutesのAuthGuardなど、認証状態の変化に伴う副作用のトリガーになる
	 */
	const signInCallback = () => {
		setIsSignedIn(true);
	};

	/**
	 * サインアウト時に呼び出される
	 * RoutesのAuthGuardなど、認証状態の変化に伴う副作用のトリガーになる
	 */
	const signOutCallback = () => {
		setIsSignedIn(false);
	};

	// Contextの初期化
	const value: AuthContextType = {
		isSignedIn,
		signInCallback,
		signOutCallback,
	};

	// 初期化処理
	const [initialized, setInitialized] = useState(false);

	useLayoutEffect(() => {
		AuthWrapper.isSignIn().then((isSignIn) => {
			if (isSignIn) {
				signInCallback();
			} else {
				signOutCallback();
			}
			setInitialized(true);
		});
	});

	if (!initialized) {
		return (
			<>
				<CircleLoadingScreen />
			</>
		);
	} else {
		return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
	}
};
